export const countries = [
  { label: "Afghanistan", value: "Afghanistan" },
  { label: "Afrique du Sud", value: "Afrique du Sud" },
  { label: "Albanie", value: "Albanie" },
  { label: "Algérie", value: "Algérie" },
  { label: "Allemagne", value: "Allemagne" },
  { label: "Andorre", value: "Andorre" },
  { label: "Angola", value: "Angola" },
  { label: "Anguilla", value: "Anguilla" },
  { label: "Antarctique", value: "Antarctique" },
  { label: "Antigua et Barbuda", value: "Antigua et Barbuda" },
  { label: "Arabie Saoudite", value: "Arabie Saoudite" },
  { label: "Argentine", value: "Argentine" },
  { label: "Arménie", value: "Arménie" },
  { label: "Aruba", value: "Aruba" },
  { label: "Australie", value: "Australie" },
  { label: "Autriche", value: "Autriche" },
  { label: "Azerbaïdjan", value: "Azerbaïdjan" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Bahreïn", value: "Bahreïn" },
  { label: "Barbade", value: "Barbade" },
  { label: "Belgique", value: "Belgique" },
  { label: "Bengladesh", value: "Bengladesh" },
  { label: "Bermudes", value: "Bermudes" },
  { label: "Bhoutan", value: "Bhoutan" },
  { label: "Birmanie", value: "Birmanie" },
  { label: "Biélorussie", value: "Biélorussie" },
  { label: "Bolivie", value: "Bolivie" },
  { label: "Bonaire, Saint-Eustache et Saba", value: "Bonaire, Saint-Eustache et Saba" },
  { label: "Bosnie-Herzégovine", value: "Bosnie-Herzégovine" },
  { label: "Botswana", value: "Botswana" },
  { label: "Brunéi Darussalam", value: "Brunéi Darussalam" },
  { label: "Brésil", value: "Brésil" },
  { label: "Bulgarie", value: "Bulgarie" },
  { label: "Burkina Faso", value: "Burkina Faso" },
  { label: "Burundi", value: "Burundi" },
  { label: "Bénin", value: "Bénin" },
  { label: "Cambodge", value: "Cambodge" },
  { label: "Cameroun", value: "Cameroun" },
  { label: "Canada", value: "Canada" },
  { label: "Cap-Vert", value: "Cap-Vert" },
  { label: "Chili", value: "Chili" },
  { label: "Chine", value: "Chine" },
  { label: "Chypre", value: "Chypre" },
  { label: "Colombie", value: "Colombie" },
  { label: "Comores", value: "Comores" },
  { label: "Congo", value: "Congo" },
  { label: "Corée du Nord", value: "Corée du Nord" },
  { label: "Corée du Sud", value: "Corée du Sud" },
  { label: "Costa Rica", value: "Costa Rica" },
  { label: "Croatie", value: "Croatie" },
  { label: "Cuba", value: "Cuba" },
  { label: "Curaçao", value: "Curaçao" },
  { label: "Côte d'Ivoire", value: "Côte d'Ivoire" },
  { label: "Danemark", value: "Danemark" },
  { label: "Djibouti", value: "Djibouti" },
  { label: "Dominique", value: "Dominique" },
  { label: "Espagne", value: "Espagne" },
  { label: "Estonie", value: "Estonie" },
  { label: "Fiji", value: "Fiji" },
  { label: "Finlande", value: "Finlande" },
  { label: "France", value: "France" },
  { label: "Fédération de Russie", value: "Fédération de Russie" },
  { label: "Gabon", value: "Gabon" },
  { label: "Gambie", value: "Gambie" },
  { label: "Georgie", value: "Georgie" },
  { label: "Ghana", value: "Ghana" },
  { label: "Gibraltar", value: "Gibraltar" },
  { label: "Grenade", value: "Grenade" },
  { label: "Groënland", value: "Groënland" },
  { label: "Grèce", value: "Grèce" },
  { label: "Guadeloupe", value: "Guadeloupe" },
  { label: "Guam", value: "Guam" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Guernesey", value: "Guernesey" },
  { label: "Guinée", value: "Guinée" },
  { label: "Guinée Équatoriale", value: "Guinée Équatoriale" },
  { label: "Guinée-Bissau", value: "Guinée-Bissau" },
  { label: "Guyane", value: "Guyane" },
  { label: "Guyane française", value: "Guyane française" },
  { label: "Géorgie du Sud-et-les Îles Sandwich du Sud", value: "Géorgie du Sud-et-les Îles Sandwich du Sud" },
  { label: "Haïti", value: "Haïti" },
  { label: "Honduras", value: "Honduras" },
  { label: "Hong-Kong", value: "Hong-Kong" },
  { label: "Hongrie", value: "Hongrie" },
  { label: "Iles Åland", value: "Iles Åland" },
  { label: "Inde", value: "Inde" },
  { label: "Indonésie", value: "Indonésie" },
  { label: "Irak", value: "Irak" },
  { label: "Iran", value: "Iran" },
  { label: "Irlande", value: "Irlande" },
  { label: "Islande", value: "Islande" },
  { label: "Israël", value: "Israël" },
  { label: "Italie", value: "Italie" },
  { label: "Jamaïque", value: "Jamaïque" },
  { label: "Japon", value: "Japon" },
  { label: "Jersey", value: "Jersey" },
  { label: "Jordanie", value: "Jordanie" },
  { label: "Kazakhstan", value: "Kazakhstan" },
  { label: "Kenya", value: "Kenya" },
  { label: "Kirghizistan", value: "Kirghizistan" },
  { label: "Kiribati", value: "Kiribati" },
  { label: "Kosovo", value: "Kosovo" },
  { label: "Koweït", value: "Koweït" },
  { label: "La Réunion", value: "La Réunion" },
  { label: "Laos", value: "Laos" },
  { label: "Le Belize", value: "Le Belize" },
  { label: "Le Sotho", value: "Le Sotho" },
  { label: "Lettonie", value: "Lettonie" },
  { label: "Liban", value: "Liban" },
  { label: "Liberia", value: "Liberia" },
  { label: "Libye", value: "Libye" },
  { label: "Liechtenstein", value: "Liechtenstein" },
  { label: "Lituanie", value: "Lituanie" },
  { label: "Luxembourg", value: "Luxembourg" },
  { label: "Macao", value: "Macao" },
  { label: "Macédoine du Nord", value: "Macédoine du Nord" },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Malaisie", value: "Malaisie" },
  { label: "Malawi", value: "Malawi" },
  { label: "Maldives", value: "Maldives" },
  { label: "Mali", value: "Mali" },
  { label: "Malte", value: "Malte" },
  { label: "Maroc", value: "Maroc" },
  { label: "Martinique", value: "Martinique" },
  { label: "Maurice", value: "Maurice" },
  { label: "Mauritanie", value: "Mauritanie" },
  { label: "Mayotte", value: "Mayotte" },
  { label: "Mexique", value: "Mexique" },
  { label: "Micronésie", value: "Micronésie" },
  { label: "Moldavie", value: "Moldavie" },
  { label: "Monaco", value: "Monaco" },
  { label: "Mongolie", value: "Mongolie" },
  { label: "Montenegro", value: "Montenegro" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Mozambique", value: "Mozambique" },
  { label: "Namibie", value: "Namibie" },
  { label: "Nauru", value: "Nauru" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Niger", value: "Niger" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "Niué", value: "Niué" },
  { label: "Norvège", value: "Norvège" },
  { label: "Nouvelle Zélande", value: "Nouvelle Zélande" },
  { label: "Nouvelle-Calédonie", value: "Nouvelle-Calédonie" },
  { label: "Nouvelle-Guinée-Papouasie", value: "Nouvelle-Guinée-Papouasie" },
  { label: "Népal", value: "Népal" },
  { label: "Oman", value: "Oman" },
  { label: "Ouganda", value: "Ouganda" },
  { label: "Ouzbékistan", value: "Ouzbékistan" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "Palau", value: "Palau" },
  { label: "Palestine", value: "Palestine" },
  { label: "Panama", value: "Panama" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Pays-Bas", value: "Pays-Bas" },
  { label: "Philippines", value: "Philippines" },
  { label: "Pologne", value: "Pologne" },
  { label: "Polynésie française", value: "Polynésie française" },
  { label: "Porto Rico", value: "Porto Rico" },
  { label: "Portugal", value: "Portugal" },
  { label: "Pérou", value: "Pérou" },
  { label: "Qatar", value: "Qatar" },
  { label: "Roumanie", value: "Roumanie" },
  { label: "Royaume-Uni", value: "Royaume-Uni" },
  { label: "Rwanda", value: "Rwanda" },
  { label: "République Centre-Africaine", value: "République Centre-Africaine" },
  { label: "République Dominicaine", value: "République Dominicaine" },
  { label: "République Démocratique du Congo", value: "République Démocratique du Congo" },
  { label: "République Tchèque", value: "République Tchèque" },
  { label: "Sahara Occidental", value: "Sahara Occidental" },
  { label: "Saint Barthélémy", value: "Saint Barthélémy" },
  { label: "Saint Pierre et Miquelon", value: "Saint Pierre et Miquelon" },
  { label: "Saint-Christophe-et-Niévès", value: "Saint-Christophe-et-Niévès" },
  { label: "Saint-Martin (partie française)", value: "Saint-Martin (partie française)" },
  { label: "Saint-Martin (partie néerlandaise)", value: "Saint-Martin (partie néerlandaise)" },
  { label: "Saint-Siège (État du Vatican)", value: "Saint-Siège (État du Vatican)" },
  { label: "Saint-Vincent-et-les-Grenadines", value: "Saint-Vincent-et-les-Grenadines" },
  { label: "Sainte-Hélène, Ascension et Tristan da Cunha", value: "Sainte-Hélène, Ascension et Tristan da Cunha" },
  { label: "Sainte-Lucie", value: "Sainte-Lucie" },
  { label: "Salvador", value: "Salvador" },
  { label: "Samoa", value: "Samoa" },
  { label: "Samoa américaines", value: "Samoa américaines" },
  { label: "San-Marin", value: "San-Marin" },
  { label: "Sao Tomé-et-Principe", value: "Sao Tomé-et-Principe" },
  { label: "Serbie", value: "Serbie" },
  { label: "Seychelles", value: "Seychelles" },
  { label: "Sierra Leone", value: "Sierra Leone" },
  { label: "Singapour", value: "Singapour" },
  { label: "Slovaquie", value: "Slovaquie" },
  { label: "Slovénie", value: "Slovénie" },
  { label: "Somalie", value: "Somalie" },
  { label: "Soudan", value: "Soudan" },
  { label: "Sri Lanka", value: "Sri Lanka" },
  { label: "Sud Soudan", value: "Sud Soudan" },
  { label: "Suisse", value: "Suisse" },
  { label: "Suriname", value: "Suriname" },
  { label: "Suède", value: "Suède" },
  { label: "Svalbard et Jan Mayen", value: "Svalbard et Jan Mayen" },
  { label: "Swaziland", value: "Swaziland" },
  { label: "Syrie", value: "Syrie" },
  { label: "Sénégal", value: "Sénégal" },
  { label: "Tadjikistan", value: "Tadjikistan" },
  { label: "Tanzanie", value: "Tanzanie" },
  { label: "Taïwan", value: "Taïwan" },
  { label: "Tchad", value: "Tchad" },
  { label: "Terres Australes Françaises", value: "Terres Australes Françaises" },
  { label: "Territoire britannique de l'océan Indien", value: "Territoire britannique de l'océan Indien" },
  { label: "Thaïlande", value: "Thaïlande" },
  { label: "Timor oriental", value: "Timor oriental" },
  { label: "Togo", value: "Togo" },
  { label: "Tokelau", value: "Tokelau" },
  { label: "Tonga", value: "Tonga" },
  { label: "Trinité et Tobago", value: "Trinité et Tobago" },
  { label: "Tunisie", value: "Tunisie" },
  { label: "Turkménistan", value: "Turkménistan" },
  { label: "Turquie", value: "Turquie" },
  { label: "Tuvalu", value: "Tuvalu" },
  { label: "Ukraine", value: "Ukraine" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Vanuatu", value: "Vanuatu" },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Wallis et Futuna", value: "Wallis et Futuna" },
  { label: "Yémen", value: "Yémen" },
  { label: "Zambie", value: "Zambie" },
  { label: "Zimbabwe", value: "Zimbabwe" },
  { label: "Égypte", value: "Égypte" },
  { label: "Émirats Arabes Unis", value: "Émirats Arabes Unis" },
  { label: "Équateur", value: "Équateur" },
  { label: "Érythrée", value: "Érythrée" },
  { label: "États Unis", value: "États Unis" },
  { label: "Éthiopie", value: "Éthiopie" },
  { label: "Île Bouvet", value: "Île Bouvet" },
  { label: "Île Christmas", value: "Île Christmas" },
  { label: "Île Norfolk", value: "Île Norfolk" },
  { label: "Île de Man", value: "Île de Man" },
  { label: "Îles Caïmans", value: "Îles Caïmans" },
  { label: "Îles Cocos (Keeling)", value: "Îles Cocos (Keeling)" },
  { label: "Îles Cook", value: "Îles Cook" },
  { label: "Îles Falkland", value: "Îles Falkland" },
  { label: "Îles Féroé", value: "Îles Féroé" },
  { label: "Îles Heard et McDonald", value: "Îles Heard et McDonald" },
  { label: "Îles Mariannes Septentrionales", value: "Îles Mariannes Septentrionales" },
  { label: "Îles Marshall", value: "Îles Marshall" },
  { label: "Îles Pitcairn", value: "Îles Pitcairn" },
  { label: "Îles Salomon", value: "Îles Salomon" },
  { label: "Îles Turques et Caïques", value: "Îles Turques et Caïques" },
  { label: "Îles Vierges (Britaniques)", value: "Îles Vierges (Britaniques)" },
  { label: "Îles Vierges (USA)", value: "Îles Vierges (USA)" },
  { label: "Îles mineures éloignées des États-Unis", value: "Îles mineures éloignées des États-Unis" }
]

export const countryCode = [
  { label: "AF", value: "+93 Afghanistan" },
  { label: "ZA", value: "+27 Afrique du Sud" },
  { label: "AL", value: "+355 Albanie" },
  { label: "DZ", value: "+213 Algérie" },
  { label: "DE", value: "+49 Allemagne" },
  { label: "AD", value: "+376 Andorre" },
  { label: "AO", value: "+244 Angola" },
  { label: "AI", value: "+1-264 Anguilla" },
  // { label: "AQ", value: "Antarctique" }, // Pas de code de numérotation
  { label: "AG", value: "+1-268 Antigua-et-Barbuda" },
  { label: "SA", value: "+966 Arabie Saoudite" },
  { label: "AR", value: "+54 Argentine" },
  { label: "AM", value: "+374 Arménie" },
  { label: "AW", value: "+297 Aruba" },
  { label: "AU", value: "+61 Australie" },
  { label: "AT", value: "+43 Autriche" },
  { label: "AZ", value: "+994 Azerbaïdjan" },
  { label: "BS", value: "+1-242 Bahamas" },
  { label: "BH", value: "+973 Bahreïn" },
  { label: "BB", value: "+1-246 Barbade" },
  { label: "BE", value: "+32 Belgique" },
  { label: "BD", value: "+880 Bangladesh" },
  { label: "BM", value: "+1-441 Bermudes" },
  { label: "BT", value: "+975 Bhoutan" },
  { label: "MM", value: "+95 Birmanie" },
  { label: "BY", value: "+375 Biélorussie" },
  { label: "BO", value: "+591 Bolivie" },
  { label: "BQ", value: "+599 Bonaire" },
  { label: "BA", value: "+387 Bosnie-Herzégovine" },
  { label: "BW", value: "+267 Botswana" },
  { label: "BN", value: "+673 Brunéi" },
  { label: "BR", value: "+55 Brésil" },
  { label: "BG", value: "+359 Bulgarie" },
  { label: "BF", value: "+226 Burkina Faso" },
  { label: "BI", value: "+257 Burundi" },
  { label: "BJ", value: "+229 Bénin" },
  { label: "KH", value: "+855 Cambodge" },
  { label: "CM", value: "+237 Cameroun" },
  { label: "CA", value: "+1 Canada" },
  { label: "CV", value: "+238 Cap-Vert" },
  { label: "CL", value: "+56 Chili" },
  { label: "CN", value: "+86 Chine" },
  { label: "CY", value: "+357 Chypre" },
  { label: "CO", value: "+57 Colombie" },
  { label: "KM", value: "+269 Comores" },
  { label: "CG", value: "+242 Congo" },
  { label: "KP", value: "+850 Corée du Nord" },
  { label: "KR", value: "+82 Corée du Sud" },
  { label: "CR", value: "+506 Costa Rica" },
  { label: "HR", value: "+385 Croatie" },
  { label: "CU", value: "+53 Cuba" },
  { label: "CW", value: "+599 Curaçao" },
  { label: "CI", value: "+225 Côte d'Ivoire" },
  { label: "DK", value: "+45 Danemark" },
  { label: "DJ", value: "+253 Djibouti" },
  { label: "DM", value: "+1-767 Dominique" },
  { label: "ES", value: "+34 Espagne" },
  { label: "EE", value: "+372 Estonie" },
  { label: "FJ", value: "+679 Fidji" },
  { label: "FI", value: "+358 Finlande" },
  { label: "FR", value: "+33 France" },
  { label: "RU", value: "+7 Russie" },
  { label: "GA", value: "+241 Gabon" },
  { label: "GM", value: "+220 Gambie" },
  { label: "GE", value: "+995 Géorgie" },
  { label: "GH", value: "+233 Ghana" },
  { label: "GI", value: "+350 Gibraltar" },
  { label: "GD", value: "+1-473 Grenade" },
  { label: "GL", value: "+299 Groenland" },
  { label: "GR", value: "+30 Grèce" },
  { label: "GP", value: "+590 Guadeloupe" },
  { label: "GU", value: "+671 Guam" },
  { label: "GT", value: "+502 Guatemala" },
  { label: "GG", value: "+44 Guernesey" },
  { label: "GN", value: "+224 Guinée" },
  { label: "GQ", value: "+240 Guinée équatoriale" },
  { label: "GW", value: "+245 Guinée-Bissau" },
  { label: "GY", value: "+592 Guyana" },
  { label: "GF", value: "+594 Guyane française" },
  { label: "GS", value: "+500 Géorgie du Sud-et-les Îles Sandwich du Sud" },
  { label: "HT", value: "+509 Haïti" },
  { label: "HN", value: "+504 Honduras" },
  { label: "HK", value: "+852 Hong Kong" },
  { label: "HU", value: "+36 Hongrie" },
  { label: "AX", value: "+358 Îles Åland" },
  { label: "IN", value: "+91 Inde" },
  { label: "ID", value: "+62 Indonésie" },
  { label: "IQ", value: "+964 Irak" },
  { label: "IR", value: "+98 Iran" },
  { label: "IE", value: "+353 Irlande" },
  { label: "IS", value: "+354 Islande" },
  { label: "IL", value: "+972 Israël" },
  { label: "IT", value: "+39 Italie" },
  { label: "JM", value: "+1-876 Jamaïque" },
  { label: "JP", value: "+81 Japon" },
  { label: "JE", value: "+44 Jersey" },
  { label: "JO", value: "+962 Jordanie" },
  { label: "KZ", value: "+7 Kazakhstan" },
  { label: "KE", value: "+254 Kenya" },
  { label: "KG", value: "+996 Kirghizistan" },
  { label: "KI", value: "+686 Kiribati" },
  { label: "XK", value: "+383 Kosovo" },
  { label: "KW", value: "+965 Koweït" },
  { label: "RE", value: "+262 La Réunion" },
  { label: "LA", value: "+856 Laos" },
  { label: "BZ", value: "+501 Belize" },
  { label: "LS", value: "+266 Lesotho" },
  { label: "LV", value: "+371 Lettonie" },
  { label: "LB", value: "+961 Liban" },
  { label: "LR", value: "+231 Libéria" },
  { label: "LY", value: "+218 Libye" },
  { label: "LI", value: "+423 Liechtenstein" },
  { label: "LT", value: "+370 Lituanie" },
  { label: "LU", value: "+352 Luxembourg" },
  { label: "MO", value: "+853 Macao" },
  { label: "MK", value: "+389 Macédoine du Nord" },
  { label: "MG", value: "+261 Madagascar" },
  { label: "MY", value: "+60 Malaisie" },
  { label: "MW", value: "+265 Malawi" },
  { label: "MV", value: "+960 Maldives" },
  { label: "ML", value: "+223 Mali" },
  { label: "MT", value: "+356 Malte" },
  { label: "MA", value: "+212 Maroc" },
  { label: "MQ", value: "+596 Martinique" },
  { label: "MU", value: "+230 Maurice" },
  { label: "MR", value: "+222 Mauritanie" },
  { label: "YT", value: "+262 Mayotte" },
  { label: "MX", value: "+52 Mexique" },
  { label: "FM", value: "+691 Micronésie" },
  { label: "MD", value: "+373 Moldavie" },
  { label: "MC", value: "+377 Monaco" },
  { label: "MN", value: "+976 Mongolie" },
  { label: "ME", value: "+382 Monténégro" },
  { label: "MS", value: "+1-664 Montserrat" },
  { label: "MZ", value: "+258 Mozambique" },
  { label: "NA", value: "+264 Namibie" },
  { label: "NR", value: "+674 Nauru" },
  { label: "NI", value: "+505 Nicaragua" },
  { label: "NE", value: "+227 Niger" },
  { label: "NG", value: "+234 Nigéria" },
  { label: "NU", value: "+683 Niue" },
  { label: "NO", value: "+47 Norvège" },
  { label: "NZ", value: "+64 Nouvelle-Zélande" },
  { label: "NC", value: "+687 Nouvelle-Calédonie" },
  { label: "PG", value: "+675 Papouasie-Nouvelle-Guinée" },
  { label: "NP", value: "+977 Népal" },
  { label: "OM", value: "+968 Oman" },
  { label: "UG", value: "+256 Ouganda" },
  { label: "UZ", value: "+998 Ouzbékistan" },
  { label: "PK", value: "+92 Pakistan" },
  { label: "PW", value: "+680 Palau" },
  { label: "PS", value: "+970 Palestine" },
  { label: "PA", value: "+507 Panama" },
  { label: "PY", value: "+595 Paraguay" },
  { label: "NL", value: "+31 Pays-Bas" },
  { label: "PH", value: "+63 Philippines" },
  { label: "PL", value: "+48 Pologne" },
  { label: "PF", value: "+689 Polynésie française" },
  { label: "PR", value: "+1-787 Porto Rico" },
  { label: "PT", value: "+351 Portugal" },
  { label: "PE", value: "+51 Pérou" },
  { label: "QA", value: "+974 Qatar" },
  { label: "RO", value: "+40 Roumanie" },
  { label: "GB", value: "+44 Royaume-Uni" },
  { label: "RW", value: "+250 Rwanda" },
  { label: "CF", value: "+236 République centrafricaine" },
  { label: "DO", value: "+1-809 République dominicaine" },
  { label: "CD", value: "+243 République démocratique du Congo" },
  { label: "CZ", value: "+420 République tchèque" },
  { label: "EH", value: "+212 Sahara occidental" },
  { label: "BL", value: "+590 Saint-Barthélemy" },
  { label: "PM", value: "+508 Saint-Pierre-et-Miquelon" },
  { label: "KN", value: "+1-869 Saint-Kitts-et-Nevis" },
  { label: "MF", value: "+590 Saint-Martin" },
  { label: "SX", value: "+1-721 Saint-Martin (partie néerlandaise)" },
  { label: "VA", value: "+379 Vatican" },
  { label: "VC", value: "+1-784 Saint-Vincent-et-les-Grenadines" },
  { label: "SH", value: "+290 Sainte-Hélène" },
  { label: "LC", value: "+1-758 Sainte-Lucie" },
  { label: "SV", value: "+503 Salvador" },
  { label: "WS", value: "+685 Samoa" },
  { label: "AS", value: "+1-684 Samoa américaines" },
  { label: "SM", value: "+378 Saint-Marin" },
  { label: "ST", value: "+239 Sao Tomé-et-Principe" },
  { label: "RS", value: "+381 Serbie" },
  { label: "SC", value: "+248 Seychelles" },
  { label: "SL", value: "+232 Sierra Leone" },
  { label: "SG", value: "+65 Singapour" },
  { label: "SK", value: "+421 Slovaquie" },
  { label: "SI", value: "+386 Slovénie" },
  { label: "SO", value: "+252 Somalie" },
  { label: "SD", value: "+249 Soudan" },
  { label: "LK", value: "+94 Sri Lanka" },
  { label: "SS", value: "+211 Soudan du Sud" },
  { label: "CH", value: "+41 Suisse" },
  { label: "SR", value: "+597 Suriname" },
  { label: "SE", value: "+46 Suède" },
  { label: "SJ", value: "+47 Svalbard et Jan Mayen" },
  { label: "SZ", value: "+268 Eswatini" },
  { label: "SY", value: "+963 Syrie" },
  { label: "SN", value: "+221 Sénégal" },
  { label: "TJ", value: "+992 Tadjikistan" },
  { label: "TZ", value: "+255 Tanzanie" },
  { label: "TW", value: "+886 Taïwan" },
  { label: "TD", value: "+235 Tchad" },
  { label: "TF", value: "+262 Terres australes et antarctiques françaises" },
  { label: "IO", value: "+246 Territoire britannique de l'océan Indien" },
  { label: "TH", value: "+66 Thaïlande" },
  { label: "TL", value: "+670 Timor oriental" },
  { label: "TG", value: "+228 Togo" },
  { label: "TK", value: "+690 Tokelau" },
  { label: "TO", value: "+676 Tonga" },
  { label: "TT", value: "+1-868 Trinité-et-Tobago" },
  { label: "TN", value: "+216 Tunisie" },
  { label: "TM", value: "+993 Turkménistan" },
  { label: "TR", value: "+90 Turquie" },
  { label: "TV", value: "+688 Tuvalu" },
  { label: "UA", value: "+380 Ukraine" },
  { label: "UY", value: "+598 Uruguay" },
  { label: "VU", value: "+678 Vanuatu" },
  { label: "VE", value: "+58 Venezuela" },
  { label: "VN", value: "+84 Vietnam" },
  { label: "WF", value: "+681 Wallis-et-Futuna" },
  { label: "YE", value: "+967 Yémen" },
  { label: "ZM", value: "+260 Zambie" },
  { label: "ZW", value: "+263 Zimbabwe" },
  { label: "EG", value: "+20 Égypte" },
  { label: "AE", value: "+971 Émirats arabes unis" },
  { label: "EC", value: "+593 Équateur" },
  { label: "ER", value: "+291 Érythrée" },
  { label: "US", value: "+1 États-Unis" },
  { label: "ET", value: "+251 Éthiopie" },
  { label: "BV", value: "+47 Île Bouvet" },
  { label: "CX", value: "+61 Île Christmas" },
  { label: "NF", value: "+672 Île Norfolk" },
  { label: "IM", value: "+44 Île de Man" },
  { label: "KY", value: "+1-345 Îles Caïmans" },
  { label: "CC", value: "+61 Îles Cocos" },
  { label: "CK", value: "+682 Îles Cook" },
  { label: "FK", value: "+500 Îles Malouines" },
  { label: "FO", value: "+298 Îles Féroé" },
  { label: "HM", value: "+672 Îles Heard-et-MacDonald" },
  { label: "MP", value: "+1-670 Îles Mariannes du Nord" },
  { label: "MH", value: "+692 Îles Marshall" },
  { label: "PN", value: "+64 Îles Pitcairn" },
  { label: "SB", value: "+677 Îles Salomon" },
  { label: "TC", value: "+1-649 Îles Turques-et-Caïques" },
  { label: "VG", value: "+1-284 Îles Vierges britanniques" },
  

]

export const SUPPORTED_FORMATS = {
    audio: [
      "audio/mpeg", // .mp3
      "audio/wav",  // .wav
      "audio/ogg",  // .ogg
      ".mp3",
      ".wav",
      ".ogg"
    ],
    images: [
      "image/jpeg", // .jpg, .jpeg
      "image/png",  // .png
      "image/gif",  // .gif
      "image/webp", // .webp
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".webp"
    ],
    documents: [
      "application/pdf",                // .pdf
      "application/msword",             // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/vnd.ms-excel",       // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-powerpoint", // .ppt
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".ppt",
      ".pptx"
    ]
  };